import { MainContentLayout } from 'shared/ui/layout';

import { AddAppSettings } from 'features/settings/add';

export function AddSettingsPage() {
  return <MainContentLayout element={<AddAppSettings />} />;
}
